import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { getNewMovies } from '@/mocks/movies';

export default function LatestUpdates() {
  const newMovies = getNewMovies();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              每日更新最新影视资源
            </p>
          </div>
        </div>

        <div className="space-y-3">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="wide" />
          ))}
        </div>
      </div>
    </section>
  );
}